const isSleepfulness = document.body.classList.contains("sleepfulness")
function calcNavMargin() {
    const header = document.querySelector("header");
    var container = document.querySelector(".content");
    container.style.marginTop = header.offsetHeight + "px";
}
$(function () {
    if (isSleepfulness) {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother)
        //ScrollTrigger.normalizeScroll(true)
        window.addEventListener("resize", calcNavMargin);
        calcNavMargin();
        const originalSpeeds = [];
        const targets = gsap.utils.toArray(".linens .description");
        targets.forEach((t) => {
            originalSpeeds.push(t.getAttribute("data-speed"));
            t.removeAttribute("data-speed");
        });
        const reveal = gsap.utils.toArray(".reveal");
        const mm = gsap.matchMedia()
        const textAnimationConf = {
            autoAlpha: 0,
            y: 30,
            stagger: .5,
            duration: 1.7,
            paused: true
        }
        $('.progress-wrap').insertAfter("#smooth-wrapper")
        // Parallax with Scroll smoother
        const smoother = ScrollSmoother.create({
            wrapper: '#smooth-wrapper',
            content: '#smooth-content',
            smooth: 2,
            smoothTouch: .1,
            effects: true
        });
        smoother.effects(".image", { speed: "auto" })
        const mediaQuery = "(max-width: 960px)";
        const mediaQueryList = window.matchMedia(mediaQuery);

        mediaQueryList.addEventListener("change", onChange);

        onChange(mediaQueryList);
        function onChange(event) {
  
            smoother.effects().forEach(effect => {
              targets.forEach(t => {
                  if (t === effect.trigger) {
                    effect.kill();
                }
              });
            });
            
            if (!event.matches) {
                targets.forEach((t, i) => {
                  smoother.effects(t, { speed: originalSpeeds[i] });
                });
            }
            
          }
          mm.add({
            isDesktop: '(min-width: 1025px)',
            isTablet: '(max-width: 1024px)'
          }, function(context) {
              const { isTablet } = context.conditions
              //Animate copy
              reveal.forEach((container) => {
                  const linesEl = container.querySelectorAll('.line')
                  const revealAnimation = gsap.from(linesEl, textAnimationConf)
                  ScrollTrigger.create({
                          trigger: container,
                          start: isTablet ? "top +=85%" :"top +=70%",
                          end: "bottom center",
                          toggleActions: "play none none none",
                          animation: revealAnimation,
                      })
              });
              //Animate divider
              const revealDivider = gsap.from('.divider', textAnimationConf)
              ScrollTrigger.create({
                  trigger: '.divider',
                  start: isTablet ? "top +=85%" :"top +=70%",
                  end: "bottom center",
                  toggleActions: "play none none none",
                  animation: revealDivider,
              })
          })
      
                        
        //image comparison
        const element = document.getElementById("image-compare");
        const viewer = new ImageCompare(element, {
            addCircle: true,
            addCircleBlur: false,
        })
        viewer.lineWidth = 5;
        viewer.mount();
        ScrollTrigger.sort()

    }
})